export const unleashFeatureFlags = {
  createClaimInspection: "portal.claims.createinspection",
};
